import { API_BASE } from '../utils/apiConfig';

export type FiliationEventType =
  | 'page_view'
  | 'form_started'
  | 'step_viewed'
  | 'step_completed'
  | 'validation_error'
  | 'cep_error'
  | 'registration_error'
  | 'upload_error'
  | 'registration_created'
  | 'completed'
  | 'page_exit';

interface TrackEventInput {
  eventType: FiliationEventType;
  step?: number;
  section?: string;
  errorCode?: string;
  affiliateId?: string;
  metadata?: Record<string, unknown>;
}

const VISITOR_KEY = 'filiacao_analytics_visitor_id';
const SESSION_KEY = 'filiacao_analytics_session_id';

const createUuid = (): string => {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = Math.floor(Math.random() * 16);
    const value = char === 'x' ? random : (random & 0x3) | 0x8;
    return value.toString(16);
  });
};

const getOrCreateId = (storage: Storage, key: string): string => {
  const current = storage.getItem(key);
  if (current) return current;
  const id = createUuid();
  storage.setItem(key, id);
  return id;
};

const visitorId = getOrCreateId(localStorage, VISITOR_KEY);
const sessionId = getOrCreateId(sessionStorage, SESSION_KEY);

const getCampaign = () => {
  const params = new URLSearchParams(window.location.search);
  return {
    utmSource: params.get('utm_source') || undefined,
    utmMedium: params.get('utm_medium') || undefined,
    utmCampaign: params.get('utm_campaign') || undefined,
  };
};

export const trackFiliationEvent = (input: TrackEventInput): void => {
  const payload = {
    sessionId,
    visitorId,
    path: window.location.pathname,
    referrer: document.referrer || undefined,
    ...getCampaign(),
    ...input,
  };

  void fetch(`${API_BASE}/filiation-analytics/events`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    keepalive: input.eventType === 'page_exit',
  }).catch(() => {
    // Métricas nunca podem bloquear o cadastro público.
  });
};

export const finishFiliationTracking = (affiliateId?: string): void => {
  trackFiliationEvent({
    eventType: 'completed',
    step: 3,
    section: 'documentos',
    affiliateId,
  });
  sessionStorage.removeItem(SESSION_KEY);
};
